import React from 'react';
import { PencilSquareIcon } from '@heroicons/react/24/solid';
import { formatDate } from 'shared_items/formatConventions';

// ###### HELPERS
const formatValue = (v) => {
  if (v === null || v === undefined) return '—';
  const n = parseFloat(v);
  if (isNaN(n)) return '—';
  if (Math.abs(n) >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (Math.abs(n) >= 1_000) return `${(n / 1_000).toFixed(1)}k`;
  return n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const ReturnCard = ({ returnItem, style, onClick }) => {
  return (
    <div
      style={style}
      className="border-b border-gray-100 hover:bg-gray-50/80 transition-colors duration-150 px-2 py-1.5 flex items-center gap-2"
    >
      {/* Left: edit icon */}
      <div className="flex items-center justify-center shrink-0">
        {onClick && (
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); onClick(returnItem); }}
            className="p-1 rounded hover:bg-gray-200 text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0"
            title="Editar"
          >
            <PencilSquareIcon className="h-4 w-4" />
          </button>
        )}
      </div>

      {/* Center: date + asset */}
      <div className="min-w-0 flex-1 flex flex-col gap-0.5">
        <div className="text-xs text-gray-500">
          {formatDate(returnItem?.payment_date, 'display')}
          {returnItem?.quantity_at_time != null && (
            <span className="ml-1">· qty {formatValue(returnItem.quantity_at_time)}</span>
          )}
        </div>
        <div className="flex items-center gap-1.5 flex-wrap">
          <span className="text-sm font-medium text-gray-900 truncate">
            {returnItem?.asset_name ?? '—'}
          </span>
          <span className="text-xs font-mono text-gray-500 bg-gray-100 px-1 py-0.5 rounded shrink-0">
            {returnItem?.asset_code ?? '—'}
          </span>
          {returnItem?.notes && (
            <span className="text-xs text-gray-400 truncate max-w-[140px]" title={returnItem.notes}>
              {returnItem.notes}
            </span>
          )}
        </div>
      </div>

      {/* Right: value + type badge */}
      <div className="flex flex-col items-end shrink-0 gap-0.5">
        <span className="text-sm font-bold text-indigo-600 tabular-nums">
          R$ {formatValue(returnItem?.payment_value)}
        </span>
        <span className="text-xs font-medium text-indigo-700 bg-indigo-50 px-1.5 py-0.5 rounded text-right" title={returnItem?.payment_type ?? '—'}>
          {returnItem?.payment_type ?? '—'}
        </span>
      </div>
    </div>
  );
};

export default ReturnCard;
